export const getLineCenter = (line: number[][]) => {
  let x = 0,
    y = 0
  for (const [lx, ly] of line) {
    x += lx
    y += ly
  }
  const len = line.length
  return [x / len, y / len]
}

// Returns angle in radians
export const angleBetweenLineStrings = (
  line1: number[][],
  line2: number[][]
): number => {
  const [x1, y1] = getLineCenter(line1)
  const [x2, y2] = getLineCenter(line2)

  const dx = x2 - x1
  const dy = y2 - y1
  // angle in radians, range (-PI, PI)
  return Math.atan2(dy, dx)
}
